import {
    mdiContentSave,
    mdiClose,
    mdiFilter,
    mdiFilterCheck,
    mdiFilterOff,
    mdiAccountRemove,
    mdiAccountOff,
    mdiAccountMultipleOutline,
    mdiWebRemove,
    mdiWebOff,
    mdiAccountMultipleCheck,
    mdiCogStop,
    mdiBadgeAccountHorizontal,
    mdiFormatListBulletedTriangle,
    mdiClipboardList,
    mdiAccount,
    mdiAccountOutline,
    mdiAccountMultiple,
    mdiAccountCancel,
    mdiAccountBox,
    mdiAccountCircle,
    mdiAccountEdit,
    mdiAccountSupervisorCircle,
    mdiAccountChild,
    mdiAccountChildCircle,
    mdiPencil,
    mdiPencilCircle,
    mdiShareVariant,
    mdiDelete,
    mdiDeleteCircle,
    mdiViewListOutline,
    mdiDeleteForever,
    mdiCheck,
    mdiAlarmPlus,
    mdiCircleSmall,
    mdiArrowDownBoldCircle,
    mdiLaptop,
    mdiTablet,
    mdiRaspberryPi,
    mdiWebCancel,
    mdiWebCheck,
    mdiWebMinus,
    mdiWebPlus,
    mdiMagnify,
    mdiAccountGroup,
    mdiAccountPlus,
    mdiAccountPlusOutline,
    mdiInformation,
    mdiInformationOutline,
    mdiWebBox,
    mdiWeb,
    mdiChevronLeftCircle,
    mdiChevronRightCircle,
    mdiSwapVertical,
    mdiSwapHorizontal,
    mdiCalendarArrowRight,
    mdiClockOutline,
    mdiClock,
    mdiFilterVariant,
    mdiAlphaOCircle,
    mdiOpenInNew,
    mdiCodeJson,
    mdiArrowLeftCircle,
    mdiPlus,
    mdiPlusCircleOutline,
    mdiPlusCircle,
    mdiLock,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiLightbulbOn,
    mdiLightbulbOnOutline,
    // mdiCalendarFilterOutline,
    // mdiCalendarFilter,
    mdiHeadQuestion,
    mdiTextBoxSearch,
    mdiAccountFilter,
    mdiDns,
    mdiArrowDecisionOutline,
    mdiFilterMultiple,
    mdiFilterMultipleOutline,
    mdiClipboardTextClock,
    mdiAccessPoint,
    mdiClipboardTextSearch,
    mdiClipboardTextSearchOutline,
    mdiRefresh,
    mdiEye,
    mdiEyeOutline,
    mdiAccountMultiplePlus,
    mdiLogout,
    mdiLogoutVariant,
    mdiRestore,
    mdiTune,
    mdiAccountKey,
    mdiKey,
    mdiKeyOutline,
    mdiDotsVertical,
    mdiDotsVerticalCircleOutline,
    mdiDotsHorizontal,
    mdiDotsHorizontalCircleOutline,
    mdiFormTextboxPassword,
    mdiWrenchClock,
    mdiTimerPlusOutline,
    mdiCarBrakeAlert,
    mdiFileDocumentMultipleOutline,
    mdiNumeric,
    mdiToggleSwitchOutline,
    mdiFormTextbox,
    mdiTableLarge,
    mdiTextBoxOutline,
    mdiCheckDecagram,
    mdiApplication,
    mdiPencilCircleOutline,
    mdiDeleteCircleOutline,
    mdiContentCopy,
    mdiDownloadCircleOutline,
    mdiCellphoneCog,
    mdiCellphone,
    mdiChevronRight,
    mdiFilePlus,
    mdiFilePlusOutline,
    mdiFileDocumentPlus,
    mdiFileDocumentPlusOutline,
    mdiMonitorEdit,
    mdiFolderPlus,
    mdiFolderPlusOutline,
    mdiFolder,
    mdiFolderOutline,
    mdiFolderOpen,
    mdiSelectGroup,
    mdiSlashForward,
    mdiAppsBox,
    mdiApps,
    mdiWhiteBalanceSunny,
    mdiWeatherNight,
    mdiAutoFix,
    mdiContentSaveCog,
    mdiContentSaveOutline,
    mdiContentSaveCogOutline,
    mdiMinus,
    mdiHelpCircleOutline,
    mdiEmoticonSadOutline,
    mdiEmoticonHappyOutline,
    mdiEmoticon,
    mdiEmoticonExcited,
    mdiEmoticonExcitedOutline,
    mdiBookOpenBlankVariant,
    mdiLoading,
    mdiApplicationCogOutline,
    mdiCalendarRange,
    mdiCalendarRangeOutline,
    mdiClockTimeTwoOutline,
    mdiClockTimeOneOutline,
    mdiClockTimeThreeOutline,
    mdiClockTimeFiveOutline,
    mdiClockTimeFourOutline,
    mdiClockTimeSixOutline,
    mdiClockTimeSevenOutline,
    mdiClockTimeEightOutline,
    mdiClockTimeNineOutline,
    mdiClockTimeTenOutline,
    mdiClockTimeElevenOutline,
    mdiClockTimeTwelveOutline,
    mdiMapClock,
    mdiCircle,
    mdiCircleMedium,
    mdiAlertCircle, mdiPencilOffOutline, mdiOrderAlphabeticalAscending, mdiOrderBoolAscending, mdiCog, mdiRadioboxBlank, mdiChartPie, mdiTimerOutline, mdiFileDocumentOutline,
    mdiMoonWaningCrescent,
    mdiTimerSand,
    mdiMinusCircleOutline,
    mdiCloseCircleOutline,
    mdiLockOutline
} from '@mdi/js'

export default {

    data () {
        return {
            icons: {
                mdiAccessPoint,
                mdiAccount,
                mdiAccountBox,
                mdiAccountCancel,
                mdiAccountChild,
                mdiAccountChildCircle,
                mdiAccountCircle,
                mdiAccountEdit,
                mdiAccountFilter,
                mdiAccountGroup,
                mdiAccountKey,
                mdiAccountMultiple,
                mdiAccountMultipleCheck,
                mdiAccountMultipleOutline,
                mdiAccountMultiplePlus,
                mdiAccountOff,
                mdiAccountOutline,
                mdiAccountPlus,
                mdiAccountPlusOutline,
                mdiAccountRemove,
                mdiAccountSupervisorCircle,
                mdiAlarmPlus,
                mdiAlphaOCircle,
                mdiApplication,
                mdiApps,
                mdiAppsBox,
                mdiArrowDecisionOutline,
                mdiArrowDownBoldCircle,
                mdiArrowLeftCircle,
                mdiAutoFix,
                mdiBadgeAccountHorizontal,
                mdiCalendarArrowRight,
                mdiCarBrakeAlert,
                mdiCellphone,
                mdiCellphoneCog,
                mdiCheck,
                mdiCheckCircle,
                mdiCheckDecagram,
                mdiChevronLeftCircle,
                mdiChevronRight,
                mdiChevronRightCircle,
                mdiCircleSmall,
                mdiClipboardList,
                mdiClipboardTextClock,
                mdiClipboardTextSearch,
                mdiClipboardTextSearchOutline,
                mdiClock,
                mdiClockOutline,
                mdiClose,
                mdiCloseCircle,
                mdiCodeJson,
                mdiCogStop,
                mdiContentCopy,
                mdiContentSave,
                mdiDelete,
                mdiDeleteCircle,
                mdiDeleteCircleOutline,
                mdiDeleteForever,
                mdiDns,
                mdiDotsHorizontal,
                mdiDotsHorizontalCircleOutline,
                mdiDotsVertical,
                mdiDotsVerticalCircleOutline,
                mdiDownloadCircleOutline,
                mdiEye,
                mdiEyeOutline,
                mdiFileDocumentMultipleOutline,
                mdiFileDocumentPlus,
                mdiFileDocumentPlusOutline,
                // mdiCalendarFilterOutline,
                // mdiCalendarFilter,
                mdiFilePlus,
                mdiFilePlusOutline,
                mdiFilter,
                mdiFilterCheck,
                mdiFilterMultiple,
                mdiFilterMultipleOutline,
                mdiFilterOff,
                mdiFilterVariant,
                mdiFolder,
                mdiFolderOpen,
                mdiFolderOutline,
                mdiFolderPlus,
                mdiFolderPlusOutline,
                mdiFormTextbox,
                mdiFormTextboxPassword,
                mdiFormatListBulletedTriangle,
                mdiHeadQuestion,
                mdiInformation,
                mdiInformationOutline,
                mdiKey,
                mdiKeyOutline,
                mdiLaptop,
                mdiLightbulbOn,
                mdiLightbulbOnOutline,
                mdiLock,
                mdiLogout,
                mdiLogoutVariant,
                mdiMagnify,
                mdiMonitorEdit,
                mdiNumeric,
                mdiOpenInNew,
                mdiPencil,
                mdiPencilCircle,
                mdiPencilCircleOutline,
                mdiPlus,
                mdiPlusCircle,
                mdiPlusCircleOutline,
                mdiRaspberryPi,
                mdiRefresh,
                mdiRestore,
                mdiSelectGroup,
                mdiShareVariant,
                mdiSlashForward,
                mdiSwapHorizontal,
                mdiSwapVertical,
                mdiTableLarge,
                mdiTablet,
                mdiTextBoxOutline,
                mdiTextBoxSearch,
                mdiTimerPlusOutline,
                mdiToggleSwitchOutline,
                mdiTune,
                mdiViewListOutline,
                mdiWeatherNight,
                mdiWeb,
                mdiWebBox,
                mdiWebCancel,
                mdiWebCheck,
                mdiWebMinus,
                mdiWebOff,
                mdiWebPlus,
                mdiWebRemove,
                mdiWhiteBalanceSunny,
                mdiWrenchClock,
                mdiContentSaveCog,
                mdiContentSaveOutline,
                mdiContentSaveCogOutline,
                mdiMinus,
                mdiHelpCircleOutline,
                mdiEmoticonSadOutline,
                mdiEmoticonHappyOutline,
                mdiEmoticon,
                mdiEmoticonExcited,
                mdiEmoticonExcitedOutline,
                mdiBookOpenBlankVariant,
                mdiLoading,
                mdiApplicationCogOutline,
                mdiMapClock,
                mdiCalendarRange,
                mdiCalendarRangeOutline,
                mdiClockTimeOneOutline,
                mdiClockTimeTwoOutline,
                mdiClockTimeThreeOutline,
                mdiClockTimeFourOutline,
                mdiClockTimeFiveOutline,
                mdiClockTimeSixOutline,
                mdiClockTimeSevenOutline,
                mdiClockTimeEightOutline,
                mdiClockTimeNineOutline,
                mdiClockTimeTenOutline,
                mdiClockTimeElevenOutline,
                mdiClockTimeTwelveOutline,
                mdiCircle,
                mdiCircleMedium,
                mdiAlertCircle,
                mdiPencilOffOutline,
                mdiOrderAlphabeticalAscending,
                mdiOrderBoolAscending,
                mdiCog,
                mdiRadioboxBlank,
                mdiTimerOutline,
                mdiChartPie,
                mdiFileDocumentOutline,
                mdiMoonWaningCrescent,
                mdiTimerSand,
                mdiMinusCircleOutline,
                mdiCloseCircleOutline,
                mdiLockOutline
            }
        }
    }
}
